import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Settings, CheckCircle2 } from 'lucide-react';
export function Installation() {
  return <section className="py-24 bg-[#0f0f16]" data-id="element-172">
      <div className="container mx-auto px-4 md:px-6" data-id="element-173">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-174">
          <div className="lg:w-1/2" data-id="element-175">
            <div className="relative rounded-2xl overflow-hidden border border-gray-800 shadow-2xl bg-[#0a0a0f]" data-id="element-176">
              <img src="https://cdn.magicpatterns.com/uploads/p2GhBPQWWW4LPKA2sqNu8G/hardware_tika.png" alt="TIKA Digital Key Hardware Modul und App" className="w-full h-full object-contain" data-id="element-177" />
            </div>
          </div>

          <div className="lg:w-1/2" data-id="element-178">
            <SectionHeading title="Hardware-Installation: Professionell & Rückrüstbar" subtitle="Unser Hardware-Modul wird sicher im Fahrzeug verbaut, ohne bestehende Kabel zu beschädigen." data-id="element-179" />

            <div className="space-y-6 mt-8" data-id="element-180">
              <div className="flex gap-4" data-id="element-181">
                <div className="mt-1" data-id="element-182">
                  <CheckCircle2 className="w-6 h-6 text-cyan-500" data-id="element-183" />
                </div>
                <div data-id="element-184">
                  <h4 className="text-white font-bold mb-1" data-id="element-185">
                    Keine Kabelschäden
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-186">
                    Installation erfolgt über T-Harness Adapter, ohne OEM-Kabel
                    zu durchtrennen. Garantie bleibt erhalten.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-187">
                <div className="mt-1" data-id="element-188">
                  <CheckCircle2 className="w-6 h-6 text-cyan-500" data-id="element-189" />
                </div>
                <div data-id="element-190">
                  <h4 className="text-white font-bold mb-1" data-id="element-191">
                    Vollständig Reversibel
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-192">
                    Das System kann jederzeit rückstandsfrei entfernt werden –
                    ideal für Leasingfahrzeuge.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-193">
                <div className="mt-1" data-id="element-194">
                  <CheckCircle2 className="w-6 h-6 text-cyan-500" data-id="element-195" />
                </div>
                <div data-id="element-196">
                  <h4 className="text-white font-bold mb-1" data-id="element-197">Komponenten</h4>
                  <p className="text-gray-400 text-sm" data-id="element-198">
                    Fahrzeug-Steuermodul, Kommunikationsmodul (4G/BLE),
                    Smart-Key-Box.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}